import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import Internaciones from '../internaciones/admin_internaciones.vue';
import PacienteService from '../../services/paciente_service.js';
import InternacionService from '../../services/internacion_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const internacionService = new InternacionService();
const pacienteService = new PacienteService();

let _this = null;
export default {
	name: 'internacionesa',
	components: { Internaciones },
	props: { seleccionarInternacion: Function, cellClick: Function },
	data: function() {
		return {
			titulo: 'Seleccionar internacion',
			loginService: loginService,
			parent: this,
			actions: [{
				icon: 'check',
				name: 'Seleccionar internacion',
				actionBtn: this.seleccionarInternacion,
				buttonClass: 'btn btn-xs btn-primary',
				hide: function() {  return true  }
			}],			
			columns: [
				{key: 'idInternacion', value: 'Id'},
				{key: 'nomyApPaciente', value: 'Paciente'},
				{key: 'dniPaciente', value: 'DNI'},
				{key: 'edadPaciente', value: 'Edad'},
				{key: 'obraSocialPaciente', value: 'Obra Social'},
				{key: 'sexoPaciente', value: 'Sexo'},
				{key: 'nroHcPaciente', value: 'Historia Clinica'},
				{key: 'tipoInternacion', value: 'Tipo'},
				{key: 'ambulatorioInternacion', value: 'Ambulatorio'},
				{key: 'camaInternacion', value: 'Cama'},
				{key: 'diagnosticoInternacion', value: 'Diagnostico'},
				{key: 'idReInternacion', value: 'Re Internacion'},
				{key: 'idUserAnteriorInternacion', value: 'Usuario Re Internacion'},
				{key: 'nombreStaffInternacion', value: 'Staff'},
				{key: 'especialidadInternacion', value: 'Especialidad'},
			]
		}
	},
	created: function () {
		_this = this;
		this.submited = false;
		if(!loginService.hasPermission("listado", "Internacions")) {
			routeService.goToHome();
			return;
		}
		/*this.getObrasSociales();
		this.getData();*/
	},
	methods: { 
		getData: function () {
			internacionService.get(this.search).then(function(response) {
				_this.data = [];
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.data.push({
							idInternacion: value.idInternacion,
							idPacienteInternacion: value.idPacienteInternacion,
							tipoInternacion: value.tipoInternacion,
							ambulatorioInternacion: value.ambulatorioInternacion == 1 ? 'SI' : 'NO',
							camaInternacion: value.camaInternacion,
							diagnosticoInternacion: value.diagnosticoInternacion,
							idReInternacion: value.idReInternacion,
							idUserAnteriorInternacion: value.idUserAnteriorInternacion,
							pacienteInternacion: pacienteService.formatPaciente(value.pacienteInternacion),
							nomyApPaciente: value.pacienteInternacion.nombrePaciente + " " + value.pacienteInternacion.apellidoPaciente,
							dniPaciente: value.pacienteInternacion.dniPaciente,
							edadPaciente: value.pacienteInternacion.edadPaciente,
							nroHcPaciente: value.pacienteInternacion.nroHcPaciente,
							obraSocialPaciente: value.pacienteInternacion.obraSocialPaciente.nombreObraSocial,
							sexoPaciente: value.pacienteInternacion.sexoPaciente == 1 ? 'M' : 'F',
							idUserInternacion: value.idUserInternacion,
							idStaffInternacion: value.idStaffInternacion,
							nombreStaffInternacion: value.nombreStaffInternacion,
							idEspecialidadInternacion: value.idEspecialidadInternacion,
							especialidadInternacion: value.especialidadInternacion.descripcionDatoParametrico,
							activoInternacion: value.activoInternacion == 1 ? 'SI' : 'NO',
							col1Internacion: value.col1Internacion,
							col2Internacion: value.col2Internacion,
							col3Internacion: value.col3Internacion,
						}); 
					} 
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		}
	}
}

